/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';
import { Button } from '@dropbox/dig-components/buttons';
import { Menu } from '@dropbox/dig-components/menu';
import { Avatar } from '@dropbox/dig-components/avatar';
import { Text } from '@dropbox/dig-components/typography';
import { Box } from '@dropbox/dig-foundations';
import 'signer-app/signer-preview/signer-dropdown.module.css';
// eslint-disable-next-line no-restricted-syntax
import { AvatarColorPalette } from '@dropbox/dig-components/dist/avatar/avatar/avatar-color-util';

export type SignerInfo = {
  id: SignerID;
  name: string;
  order?: number;
};

export type SignerMap<T = SignerInfo> = Partial<Record<SignerID, T>>;
export type SignerID =
  | 'preparer'
  | 'sender'
  | `${
      | 1
      | 2
      | 3
      | 4
      | 5
      | 6
      | 7
      | 8
      | 9
      | 10
      | 11
      | 12
      | 13
      | 14
      | 15
      | 16
      | 17
      | 18
      | 19
      | 20}`;

type Props = {
  signers: SignerMap;
  currentSigner: SignerID;
  onSelection: (key: SignerID) => void;
};
export function SignerDropdown({ signers, currentSigner, onSelection }: Props) {
  return (
    <Menu.Wrapper
      onSelection={(value) => {
        if (value) {
          onSelection(value);
        }
      }}
    >
      {({ getTriggerProps, getContentProps }) => (
        <div>
          <Button
            variant="filled"
            size="large"
            withDropdownIcon
            {...getTriggerProps()}
          >
            <SignerItem
              name={signers[currentSigner]?.name ?? ''}
              colorPallete={{
                foreground: '#fff',
                background: `var(--signer-color-${currentSigner})`,
              }}
            />
          </Button>
          <Menu.Content {...getContentProps()}>
            {Object.entries(signers).map(([signerId, { name }]) => (
              <Menu.Segment key={signerId}>
                <Menu.ActionItem
                  value={signerId}
                  interactive
                  preferComposition
                  className="custom-row"
                >
                  <SignerItem
                    name={name}
                    colorPallete={{
                      foreground: '#fff',
                      background: `var(--signer-color-${signerId})`,
                    }}
                  />
                </Menu.ActionItem>
              </Menu.Segment>
            ))}
          </Menu.Content>
        </div>
      )}
    </Menu.Wrapper>
  );
}

function SignerItem({
  name,
  colorPallete,
}: {
  name: string;
  colorPallete?: AvatarColorPalette;
}) {
  const initials = React.useMemo(
    () =>
      name
        .split(' ')
        .map((n) => n[0])
        .slice(0, 2),
    [name],
  );

  return (
    <>
      <Avatar size="medium" colorPalette={colorPallete}>
        {initials}
      </Avatar>
      <Box paddingLeft="Micro XSmall">
        <Text isBold={false}>{name}</Text>
      </Box>
    </>
  );
}
